
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tutorials/xd-components-to-figma",
      function () {
        return require("private-next-pages/tutorials/xd-components-to-figma.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tutorials/xd-components-to-figma"])
      });
    }
  